<template>
  <article class="detail-page">
    <section class="detail-page-container">
      <scope-advert-swiper :swiperImgArray="goodsImgList" :swiperWrapClass="swiperClass" :autoPlay="autoplay"></scope-advert-swiper>
      <div class="describe">
        <h3>{{ ScopeGoodsInfo.ScopeName }}</h3>
        <p class="red-text">
          <i class="iconfont icon-renminbi"></i>
          <span>{{ ScopeGoodsInfo.AdultPrice }}</span>
        </p>
        <p class="gray-text">
          <span>{{ ScopeGoodsInfo.Description }}</span>
        </p>
      </div>

      <div @click="showHideMask" class="option_btn">
        <span>选择:套餐</span>
        <i class="iconfont icon-iconfontzhizuobiaozhun19"></i>
      </div>

      <div class="details" v-html="ScopeGoodsInfo.ScopeContent"></div>
    </section>

    <scope-content-footer :btnText="'立即购买'" :isHavePrice="false" :goodsPrice="0" @showHideMask="showHideMask($event)"></scope-content-footer>
    <scope-mask-option :showMask="showMask" @showHideMask="showHideMask($event)" :ScopeGoodsInfo="ScopeGoodsInfo"></scope-mask-option>
  </article>
</template>

<script>
import scopeApi from '../request/scopeApi';
import orderApi from '../request/orderApi';
import ScopeAdvertSwiper from './child-components/ScopeAdvertSwiper';
import ScopeMaskOption from './child-components/ScopeMaskOption';
import ScopeContentFooter from './child-components/ScopeContentFooter';
export default {
  name: 'ScopeContent',
  data() {
    return {
      goodsId: null,
      ScopeGoodsInfo: {},
      swiperClass: 'big_banner_wrap',
      autoplay: true,
      showMask: false,
      goodsImgList: []
    };
  },
  components: {
    ScopeAdvertSwiper,
    ScopeMaskOption,
    ScopeContentFooter
  },
  activated() {
    if (this.$route.params.id) {
      this.goodsId = this.$route.params.id;
      this.getScopeGoodsInfo();
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    showHideMask() {
      this.showMask = !this.showMask;
    },
    getScopeGoodsInfo() {
      this.goodsImgList = [];
      var that = this;
      scopeApi.getScopeGoodsInfo(this.goodsId).then(sucRes => {
        let result = sucRes.data;
        that.ScopeGoodsInfo = result;
        that.goodsImgList.push(result.GoodsLogoUrl);
      });
    }
  }
};
</script>

<style>
.detail-page-container {
  flex: 1;
  overflow: auto;
  height: 100%;
}

.describe,
.option_btn,
.details {
  background-color: #fff;
  padding: 3%;
  margin-bottom: 10px;
}

.describe .yuanjia {
  color: #888;
  text-decoration: line-through;
  margin-left: 5px;
}

.describe .iconfont {
  margin: 0;
}

.describe h3,
.describe .jiashou {
  font-size: 0.45rem;
  font-weight: 400;
}

.describe>p:first-of-type {
  margin-top: 0.2rem;
  font-size: 0.4rem;
  color: #e22222;
}

.describe>p:last-of-type {
  color: #888;
}

.describe>p:last-of-type>span {
  margin-right: 5px;
}

.details p {
  font-size: 0.4rem;
}

.details>span {
  display: block;
  text-align: center;
  color: #e22222;
  font-size: 0.4rem;
}

.details .jiashou {
  font-weight: 600;
  color: #fff;
  background-color: #346dab;
  font-size: 0.45rem;
}

.details .addArticle {
  display: flex;
  justify-content: initial;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;
  color: #555;
}

.details .addArticle>h3,
.details .addArticle>p {
  margin: 4px auto;
}

.details .addArticle>h3 {
  font-weight: 600;
  background-color: yellow;
  font-size: 0.45rem;
  line-height: 0.6rem;
  text-indent: 0.6em;
  text-align: center;
}

.details>h3 {
  font-size: 0.42rem;
  font-weight: 600;
  text-align: center;
}

.details>p {
  text-indent: 2em;
  padding: 0 3%;
  margin: 0.2rem auto;
}

.details img {
  display: block;
  width: 95%;
  height: auto;
  margin: 0.5rem auto;
}

.option_btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: initial;
}

.option_btn span {
  font-size: 0.38rem;
}

.option_btn .iconfont {
  font-size: 0.45rem;
}

.order-container {
  flex: 1;
  overflow: auto;
}

.order-container header,
.order-container .leave-msg,
.order-container .show-price {
  background-color: #fff;
  padding: 3%;
  margin-bottom: 10px;
}

.order-container header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: initial;
  flex-direction: initial;
}

.order-container header .thumb-wrap {
  margin: 0 3%;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 20%;
  align-self: initial;
}

.order-container header .thumb-wrap img {
  width: 1.6rem;
  height: 1.6rem;
  padding: 5%;
  border: 1px solid #888;
}

.order-container header .text-description {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: initial;
  flex-direction: initial;
}

.order-container header .text-description>span {
  margin-right: 3%;
}

.order-container header .text-description>p span {
  margin-right: 5px;
}

.order-container .leave-msg {
  display: flex;
  justify-content: initial;
  align-items: center;
  flex-wrap: initial;
  flex-direction: initial;
}

.order-container .leave-msg>span,
.order-container .leave-msg>input {
  line-height: 0.8rem;
  padding-left: 3%;
}

.order-container .leave-msg>input {
  flex: 1;
  border: none;
  font-size: 0.35rem;
  padding-top: 2px;
}

.order-container .show-price p {
  line-height: 1rem;
  padding: 0 3%;
}

.order-container .show-price>p:first-child {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: initial;
  flex-direction: initial;
  border-bottom: 1px dashed #888;
}

.order-container .show-price>p:last-child {
  text-align: right;
}

.order-container>p:last-child {
  line-height: 1.2rem;
  text-align: center;
  margin-top: 10px;
}

.news-container {
  flex: 1;
  overflow: auto;
  padding: 3%;
}

.member-container {
  flex: 1;
  overflow: auto;
  padding: 3%;
}

.member-container .head-portrait {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;
}

.member-container .head-portrait img {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  margin-top: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.8);
}

.member-container .head-portrait span {
  margin: 10px auto;
  font-weight: 600;
  color: #666;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.page_title {
  background-color: #E77618;
  color: #fff;
  flex-grow: 0;
  flex-shrink: auto;
  flex-basis: 0;
  align-self: stretch;
}

.page_title .index_title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
}

.page_title .index_title h1 {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 1rem;
  align-self: stretch;
  margin: 0 3% 0 2%;
}

.page_title .index_title img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.page_title .child_page_title {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  position: relative;
}

.page_title .child_page_title>.iconfont {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%) rotateY(180deg);
  font-size: 0.5rem;
  text-align: center;
  width: 1rem;
  line-height: 1rem;
}

.page_title .child_page_title h3 {
  line-height: 1rem;
}

.page_title .index_title,
.page_title .child_page_title {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding: 6px 3%;
}

.page_title .index_title h3,
.page_title .child_page_title h3 {
  font-size: 0.4rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-indent: 2px;
}

.page-footer {
  display: flex;
  justify-content: initial;
  align-items: center;
  flex-wrap: initial;
  flex-direction: initial;
  border-top: 1px solid #ddd;
  background-color: #fff;
}

.page-footer button {
  flex: 1;
  line-height: 1.2rem;
  text-align: center;
  border: none;
  background-color: #E77618;
  color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 0.4rem;
}

.page-footer button:active {
  background-color: #ff9900;
  color: #eee;
}

.page-footer .goods-price {
  flex: 0 0 67%;
  text-align: right;
  padding-right: 3%;
}

.page-footer .goods-price>span:last-child {
  margin-right: 5px;
}

.big_banner_wrap {
  width: 100%;
  height: 4.2rem;
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);
}

.dtail-page-swiper {
  width: 100%;
  height: 6rem;
}

.detail_swiper {
  height: 5rem;
}

.paging {
  bottom: 0.3rem;
}

.mask-wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  opacity: 0;
  transition: all 0.4s;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
  display: flex;
  justify-content: flex-end;
  align-items: initial;
  flex-wrap: nowrap;
  flex-direction: column;
}

.mask-wrap.show {
  opacity: 1;
  z-index: 999;
}

.showmask-ordermodel-enter,
.showmask-ordermodel-leave-to {
  transform: translate3d(0, 100%, 0);
  opacity: 0.5;
}

.showmask-ordermodel-leave,
.showmask-ordermodel-enter-to {
  transform: translate3d(0, 0, 0);
  opacity: 1;
}

.showmask-ordermodel-enter-active,
.showmask-ordermodel-leave-active {
  transition: 0.4s;
}

.mask-container {
  background-color: #fff;
  height: 80%;
  display: flex;
  justify-content: initial;
  align-items: initial;
  flex-wrap: initial;
  flex-direction: column;
}

.mask-container.show {
  overflow: visible;
  transform: translateY(0);
}

.mask-container .select-container-wrap {
  flex: 1;
  overflow: auto;
}

.mask-container .select-container-wrap>div:last-child {
  margin-bottom: 10%;
}

.mask-container header,
.mask-container .select-item-wrap {
  width: 95%;
  margin-left: auto;
}

.mask-container header {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: initial;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.mask-container header .thumbnail-wrap {
  margin-right: 3%;
}

.mask-container header .thumbnail-wrap img {
  width: 1.6rem;
  height: 1.6rem;
  padding: 3%;
  background-color: #fff;
  border: 1px solid #888;
}

.mask-container header .text-description {
  flex: 1;
}

.mask-container header .text-description .yuanjia {
  color: #888;
  text-decoration: line-through;
  margin-left: 5px;
}

.mask-container header .text-description h3 {
  font-weight: 600;
  color: #333;
  font-size: 0.42rem;
}

.mask-container header .del-icon-wrap {
  flex: 0 0 10%;
  align-self: stretch;
  font-size: 0.45rem;
  color: #888;
  text-align: center;
  margin-right: 1%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: initial;
}

.mask-container header .del-icon-wrap .iconfont {
  display: block;
  font-size: 0.45rem;
}

.mask-container .select-item-wrap h3 {
  line-height: 0.8rem;
  font-weight: 400;
  color: #888;
  flex: 0 0 100%;
}

.mask-container .select-item-wrap .airport-wrap,
.mask-container .select-item-wrap .car-model,
.mask-container .select-item-wrap .ticket-form {
  margin-top: 0.2rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.mask-container .select-item-wrap .airport-items,
.mask-container .select-item-wrap .car-model,
.mask-container .select-item-wrap .ticket-form {
  display: flex;
  justify-content: initial;
  align-items: initial;
  flex-wrap: wrap;
  flex-direction: initial;
}

.mask-container .select-item-wrap .airport-items button,
.mask-container .select-item-wrap .car-model button,
.mask-container .select-item-wrap .ticket-form button {
  text-align: center;
  border: none;
  padding: 3px 6px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #888;
  margin: 10px 0 0 10px;
  border-radius: 4px;
}

.mask-container .select-item-wrap .airport-items button.active,
.mask-container .select-item-wrap .car-model button.active,
.mask-container .select-item-wrap .ticket-form button.active {
  background-color: #E77618;
  color: #fff;
  border-color: #E77618;
}

.mask-container .goods-amount,
.mask-container .link-man-wrap,
.mask-container .user-site,
.mask-container .phone-num-wrap,
.mask-container .date-picker,
.mask-container .time-picker,
.mask-container .leave-msg {
  padding: 3% 6%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.mask-container .goods-amount {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: initial;
}

.mask-container .goods-amount .selector {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: initial;
  border-radius: 5px;
  border: 1px solid #888;
}

.mask-container .goods-amount .selector>i:first-child {
  border-right: 1px solid #888;
  border-radius: 5px 0 0 5px;
}

.mask-container .goods-amount .selector>i:last-child {
  border-left: 1px solid #888;
  border-radius: 0 5px 5px 0;
}

.mask-container .goods-amount .selector>.iconfont {
  text-align: center;
  padding: 0 8px;
  color: #888;
  background-color: #eee;
  align-self: stretch;
  margin: 0;
}

.mask-container .goods-amount .selector>.iconfont.disabled {
  background-color: #ddd;
}

.mask-container .goods-amount .selector input {
  border: none;
  outline: none;
  width: 4em;
  align-self: stretch;
  text-align: center;
}

.mask-container .goods-amount .selector input:disabled {
  color: #E77618;
  opacity: 1;
  background-color: #fff;
}

.mask-container .link-man-wrap,
.mask-container .user-site,
.mask-container .phone-num-wrap,
.mask-container .date-picker,
.mask-container .time-picker,
.mask-container .leave-msg {
  display: flex;
  justify-content: initial;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: initial;
}

.mask-container .link-man-wrap>span:first-child,
.mask-container .user-site>span:first-child,
.mask-container .phone-num-wrap>span:first-child,
.mask-container .date-picker>span:first-child,
.mask-container .time-picker>span:first-child,
.mask-container .leave-msg>span:first-child {
  border-right: 1px solid #888;
  padding-right: 8px;
  flex: 0 0 23%;
  text-align: right;
  white-space: nowrap;
}

.mask-container .link-man-wrap input,
.mask-container .user-site input,
.mask-container .phone-num-wrap input,
.mask-container .date-picker input,
.mask-container .time-picker input,
.mask-container .leave-msg input,
.mask-container .link-man-wrap>span:last-child,
.mask-container .user-site>span:last-child,
.mask-container .phone-num-wrap>span:last-child,
.mask-container .date-picker>span:last-child,
.mask-container .time-picker>span:last-child,
.mask-container .leave-msg>span:last-child {
  border: none;
  padding-left: 8px;
  flex: 1;
  line-height: 0.8rem;
}

.mask-container .mask-footer {
  display: flex;
  justify-content: initial;
  align-items: center;
  flex-wrap: initial;
  flex-direction: initial;
}

.mask-container .mask-footer button {
  flex: 1;
  line-height: 1.2rem;
  text-align: center;
  border: none;
  background-color: #E77618;
  color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

.mask-container .mask-footer button:active {
  background-color: #ff9900;
  color: #eee;
}

/* primaryNav------------ */
.clearfix:after {
  content: '';
  display: block;
  clear: both;
}

.primaryNav {
  max-width: 100%;
  width: 95%;
  margin: 0 auto;
  overflow-x: auto;
}

.primaryNav ul {
  overflow-x: hidden;
  background-color: #f8f8f8;
}

.primaryNav ul:after {
  content: '';
  display: block;
  clear: both;
}

.primaryNav ul li {
  width: 25%;
  float: left;
  text-align: center;
}

.primaryNav ul li img {
  display: block;
  margin: 0.2rem auto;
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
}

.primaryNav ul li span {
  text-align: center;
  color: #666;
  text-indent: initial;
  /* font-size: inherit; */
  display: inline-block;
  width: 4em;
  font-weight: 400;
  max-width: 4em;
  text-overflow: clip;
}

.active {
  /* border-bottom: 2px solid #E77618; */
}

.primaryNav .navitem.active span {
  color: #E77618;
  font-weight: 600;
}

/* primaryNav------------ */


.product_list_wrap {
  min-height: 60%;
  display: flex;
  justify-content: initial;
  align-items: initial;
  flex-wrap: initial;
  flex-direction: initial;
  border-top: 2px solid rgba(0, 0, 0, 0.2);
  flex: 1;
  z-index: 10;
  color: #333;
  background-color: #e4e4e4;
}

.product_list_wrap .p_l_nav {
  width: 2rem;
  flex: 0 0 2rem;
}

.product_list_wrap .p_l_nav .nav_btn {
  width: 100%;
  /* text-overflow: clip; */
  /* white-space: nowrap; */
  text-align: center;
  font-size: .35rem;
  letter-spacing: 1px;
  display: block;
  line-height: .8rem;
  /* border-right: 1px solid #888; */
  /* border-radius: 5px; */
  border-bottom: 1px solid #eee;
  background-color: #fff;
  box-sizing: border-box;
  text-overflow: clip;
  overflow: hidden;
  padding: .5rem 0 .5rem 6px;
}

.product_list_wrap .p_l_nav .active {
  background-color: #e4e4e4;
  color: #E77618;
  border-right: none;
  border-left: 4px solid #E77618;
}

.product_list_wrap .p_l_nav .active+.nav_btn {
  border-top-right-radius: 5px;
}


.product_list_wrap .product_exhibition {
  flex: 1;
  margin-top: 2px;
}

.product_list_wrap .product_exhibition .floor-item {
  padding: 5%;
  z-index: 1;
  /* margin: 0.3rem; */
  /* background-color: #fff; */
}

.product_list_wrap .product_exhibition .floor-item>p:first-child {
  background-color: #E77618;
  padding-left: 5px;
  color: #fff;
  font-weight: 600;
}

.product_list_wrap .product_exhibition .floor-item>ul {
  margin-top: 10px;
}

.product_list_wrap .product_exhibition .floor-item>ul .product-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: initial;
  flex-direction: initial;
  margin-top: 15px;
  background-color: #fff;
}

.product_list_wrap .product_exhibition .floor-item>ul .product-list-item>.goods_info {
  display: flex;
  justify-content: initial;
  align-items: flex-end;
  flex-wrap: nowrap;
  flex-direction: column;
  flex: 1;
}

.product_list_wrap .product_exhibition .floor-item>ul .product-list-item>.goods_info .iconfont {
  margin: 0 5px 0 0;
}

.product_list_wrap .product_exhibition .floor-item>ul .product-list-item h3 {
  text-align: right;
  color: #666;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.4);
  padding-right: 5px;
}

.product_list_wrap .product_exhibition .floor-item>ul .product-list-item span {
  max-width: 10em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 5px;
  white-space: nowrap;
}

.product_list_wrap .product_exhibition .floor-item>ul .product-list-item img {
  width: 1.6rem;
  max-width: 1.6rem;
  height: 1.6rem;
  /* padding: 0.16rem; */
  /* border: 1px solid #888; */
  text-align: center;
}

.padding {
  padding-left: 2rem;
}

/* .floor-item, */
.floor-item>p:first-child,
.floor-item>ul>li {
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.product-list-item {
  justify-content: space-between;
  border-radius: 5px;
  padding: 0.2rem;
}

/* .news {
  flex: 1;
}

.inputs_wrap>div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: initial;
}

.inputs_wrap>div>span {
  padding-right: 8px;
  border-right: 1px solid #888;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 22%;
  align-self: initial;
  text-align: right;
}

.inputs_wrap>div>input {
  padding-left: 8px;
  line-height: 0.8rem;
  border: none;
}

.member-info {
  border-radius: 5px;
  border: 1px solid #888;
}

.member-info>div {
  padding: 0.2rem 3%;
}

.member-info>div:nth-last-child(n+2) {
  border-bottom: 1px solid #888;
} */
</style>



// WEBPACK FOOTER //
// src/components/ScopeContent.vue